/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  ShippingAndBilling.tsx
*
* Project Title :  Checkout
*
* Description	:
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Avanthi G(E860178)
*
* @Date			    : Jul 29, 2019
*
* @Version      : Version 1.0
 *
 *  By            : Sivateja (H267743)
 * On            : Aug 05, 2019
 * Description   : Updated code for ASDS-685 with static data and styles.
 *
 *  By            : Sivateja (H267743)
 * On            : Aug 05, 2019
 * Description   : Updated code for ASDS-686, implemented functionality for showing select Account ,the change account on click
 *
 *  By            : Madhu Gali (H175591)
 * On            : Aug 05, 2019
 * Description   : ASDS-922: UI Integration- Shipping and Billing - Email Confirmation
 *
 * By            : H352615
 * On            : Aug 07, 2019
 * Description   : Shipping & Billing - Account & Address Information - Dynamic data. - ASDS-951
 *
 * By            : Madhu Gali
 * On            : Aug 08, 2019
 * Description   : ASDS-955: Shipping & Billing - Payment Info - PO - API integration
 *
 * By            : Madhu Gali
 * On            : Aug 08, 2019
 * Description   : ASDS-985: Shipping & Billing - PO switching logic
 *
 * By            : Avanthi G (E860178)
 * On            : Aug 12, 2019
 * Description   : Added setPaymentInfo function to connect to store (ASDS-956).
 *
 * By            : H352615
 * On            : Aug 13, 2019
 * Description   : Integrated with OrderSummary.tsx
 *
 * By            : Madhu Gali (H175591)
 * On            : Aug 16, 2019
 * Description   : ASDS-958: Shipping & Billing alignment issues
 *
 * By            : H352615
 * On            : Aug 13, 2019
 * Description   : Fixed ASDS-1053.
 *
 * By            : Madhu Gali (H175591)
 * On            : Aug 23, 2019
 * Description   : ASDS-1089: Ability to add Email Functionality & Validations.
 *
 * By: Madhu Gali
 * On: Sep 09, 2019
 * Description: ASDS-1199: User Navigation - Payment Method Issues - Active tab validation
 *
 * By            : Madhu Gali (H175591)
 * On            : Sep 10, 2019
 * Description   : ASDS-1200
 * By            : Avanthi G (E860178)
 * On            : Sep 13, 2019
 * Description   : User Focus on click of Review&Place order button - ASDS-1172
 *
 * By            : Madhu Gali
 * On            : Sep 19 2019
 * Description   : ASDS-165
 *
 * By            : Deepthi Bachu
 * On            : Sep 25 2019
 * Description   : ASDS-1285
 *
 * By            : sivateja. peram
 * On            : Sep 30 2019
 * Description   : ASDS-1288
 *
 * By            	: Madhu Gali (H175591)
 * On            	: Oct 03, 2019
 * Description   : ASDS-1495
 *
 * By            : Sivateja (H267743)
 * On            : OCT 10, 2019
 * Description   : added saving details to session storage on click of next (ASDS-1477)
 *
 * By            : H224423
 * On            : Oct 10, 2019
 * Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes
 *
 * By            	: Madhu Gali - H175591
 * On            	: Oct 10, 2019
 * Description   : ASDS-1476
 *
 * By            	: sivateja.p (H267743)
 * On            	: Oct 10, 2019
 * Description      : Moved confirmcheck box from state to props, implemented page data reset on refesh(ASDS-1296)
 *
 * By            	: SandeepRaja (E807238)
 * On            	: Oct 14, 2019
 * Description    : ASDS-1297: Page Level refresh - Review Order
 *
 * By            : SandeepRaja (E807238)
 * On            : Oct 17, 2019
 * Description   : ASDS-113: Configure and purchase 131-9 APU through PO
 *
 * By            : E807238
 * On            : Nov 05, 2019
 * Description   : ASDS-1679: PO date, Upload PO document as optional fields
 *
 * By            : H224423
 * On            : NOV 08, 2019
 * Description   : Removed double rendered HR to once
 *
 * By            : Sandeep Raja
 * On            : 20 Nov 2019
 * Description   : ASDS-1643: Tax Service Exception Scenario
 *
 * By            : E807958
 * On            : 25 Nov 2019
 * Description   : ASDS-1676
 *
 * By            : Madhu Gali - H175591
 * On            : Dec 03 2019
 * Description   : ASDS-1964
 *
 * By            : SandeepRaja
 * On            : Dec 03, 2019
 * Description   : ASDS-1951: Change Account-Delete APU MSA from Cart
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1961 - Add validation for PO Date field to prevent future date(manual entry)
 *
 * By            : Madhu Gali - H175591
 * On            : Dec 03 2019
 * Description   : ASDS-1964
 *
 * By            : H224423
 * On            : Dec 9, 2019
 * Description   : Removed shipping & billing checkbox
 *
 * By            	: Madhu Gali
 * On            	:  Dec 18, 2019
 * Description      : ASDS-584
 *
 * By            : Srinivas Grandhi (E528634)
 * On            : Jan 06,2020
 * Description   : updated code as per ASDS-1764.

 *  *
 * By            : Snigdha K (H224699)
 * On            : Jan 10 ,2020
 * Description   : updated code as per ASDS-608.

 *
 * By            : Deepthi Bachu (E844276)
 * On            : Jan 9th, 2020
 * Description   : updated the code to place review order button under order summary
 *
 * By            : H224423
 * On            : Jan 23, 2019
 * Description   : Po Tab issue fixes.
 *
 * By            : H224423
 * On            : Jan 23, 2019
 * Description   : Po Document conversion changes
 *
 * By            : H224423
 * On            : Feb 13, 2019
 * Description   : ASDS-2055 Change account delete MSA APU product.
 *
 * By            : H224423
 * On            : Feb 17, 2019
 * Description   : ASDS-2055 => ASDS-2346 issue fixes.
 * By            : Srinivas Grandhi (E528634)
 * On            : Feb 17,2020
 * Description   : updated code as per ASDS-403.
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H422336
 * On            : Sep 08, 2020
 * Description   : ASDS-2751 UI Enhancements for Phase II
 *
 * By            : H422336
 * On            : Sep 11, 2020
 * Description   : ASDS-2989 UI Enhancements phase II
 *
 *
 * By             : H422336
 * On             : Oct 06,2020
 * Description    : ASDS-3227 APU enhancements as part of phase-2
 *
 * By            : H422337
 * On            : Oct 08, 2020
 * Description   : ASDS - 3228 UI Enhancements for Phase - II
 *
 * By             : H422336
 * On             : Oct 22,2020
 * Description    : ASDS-3580 APU Enhancements Phase-II
 *
 * By            : H422335
 * On            : 26 Nov, 2020
 * Description   : ASDS-4086 - PO Date field improvement, Update to credit card failure notification
 ******************************************************************************/

import * as React from 'react';
import {
  Grid,
  Card,
  Button,
  InputLabel,
  Notification,
  Accordion,
} from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './ShippingAndBilling.css';
import '@scuf/styles/variables.scss';
import {
  validatePONumber, validatePODate, GetFormattedDate, validatePODoc, default as PaymentOptions
} from './PaymentOptions';
import OrderSummery from '../OrderSummery/OrderSummery';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import RouteConstants from '../constants/route-constants';
import { IcheckoutProps, IcheckoutState, IBreadcrumbLink } from '../utils/checkout-interfaces';
import SelectAccount from '../SelectAccount/selectAccount';
import { connect } from 'react-redux';
import { AddressDetails } from '../../../types/';
import ShippingBillingActions from '../redux/actions/shipping-billing-actions';
import Layout from '../Layout/Layout';
import AddEmailAddress from './AddEmailAddress';
import CheckoutConstants, { CheckoutUILabels } from '../constants/checkout-constants';
import ShippingAndBillingAddress, { mapSelectAccountToProps } from './ShippingAndBillingAddress';
import {
  submitCCFrom,
  getSubmitSuccessValue,
} from '../Payment/ccActions.jsx';
import PaymetricActions from '../redux/actions/paymetric-actions';
import { logInfo } from '../../../utils/console-utility';
import { loadState, saveState } from '../../../config/sessionStorage';
import TaxStatusMessage from '../OrderSummery/TaxStatusMessage';
import DeleteMSAProduct from '../SelectAccount/DeleteMSAProducts';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import GenericLoader from '../Loader/Loader';
import DeleteDLMUWProduct from '../SelectAccount/DeleteDLMUWProduct';
import RouteNames from '../constants/route-names';
import BreadcrumbComponent from '../BreadcrumbComponent/BreadcrumbComponent';

export class ShippingAndBilling extends React.Component<IcheckoutProps & RouteComponentProps, IcheckoutState> {
  constructor(props: IcheckoutProps & RouteComponentProps) {
    super(props);
    this.state = {
      shouldDisplaySelectAccount: false,
      shouldDisplayDeleteCart: false,
      shouldDisplayDlmuwDeleteCart: false,
      open: false,
      hasClickOut: true,
      fields: {},
      errors: {},
      poFilepath: '',
      poDoc: {},
      payTerm: '',
      activePaymentTab: 0,
      openPaymentOptions: true
    };

    this.validatePOForm = this.validatePOForm.bind(this);
    this.handleRetry = this.handleRetry.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePaymentOptions = this.handlePaymentOptions.bind(this);
    this.validatePOTabFields = this.validatePOTabFields.bind(this);
    this.backToMyCart = this.backToMyCart.bind(this);
    this.goToReviewOrderPage = this.goToReviewOrderPage.bind(this);
    this.toggleSelectAccount = this.toggleSelectAccount.bind(this);
    this.writeToSessionState = this.writeToSessionState.bind(this);
    this.doEnableReviewOrderBtn = this.doEnableReviewOrderBtn.bind(this);
    this.readPODocument = this.readPODocument.bind(this);
    this.toggleDisplayDeleteCart = this.toggleDisplayDeleteCart.bind(this);
    this.onChangeAccountClick = this.onChangeAccountClick.bind(this);
    this.toggleDisplayDlmuwDeleteCart = this.toggleDisplayDlmuwDeleteCart.bind(this);
    this.backToProductListing = this.backToProductListing.bind(this);
  }

  updateActivePaymentTab(activeTabIndex) {
    this.setState({
      activePaymentTab: activeTabIndex,
    });
    this.props.incrementCount();
    this.props.identifyTabLevelError(activeTabIndex);
  }

  toggleSelectAccount() { /*ASDS-686*/
    this.setState({
      shouldDisplayDeleteCart: false,
      shouldDisplayDlmuwDeleteCart: false,
      shouldDisplaySelectAccount: !this.state.shouldDisplaySelectAccount,
    });
  }

  onChangeAccountClick() {
    const selectedCartList = this.props.selectedCartList;
    let doesCartHaveMSAProds: boolean = false;
    let doesCartHaveDlmuwProducts: boolean = false;
    if (selectedCartList) {
      selectedCartList.cartList.forEach(prodInCart => {
        if (prodInCart.apuProductConfig && prodInCart.apuProductConfig.customerType && prodInCart.apuProductConfig.customerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA) {
          doesCartHaveMSAProds = true;
        } else if (prodInCart.categoryName.toLowerCase().includes(CheckoutConstants.DLMUW_CATEGORY_NAME)){
          doesCartHaveDlmuwProducts = true;
        }
      });
    }
    if (doesCartHaveMSAProds) {
      this.toggleDisplayDeleteCart();
    }  else if (doesCartHaveDlmuwProducts) {
      this.toggleDisplayDlmuwDeleteCart();
    } else {
      this.toggleSelectAccount();
    }
  }

  toggleDisplayDeleteCart() {
    this.setState({
      shouldDisplayDeleteCart: !this.state.shouldDisplayDeleteCart,
    });
  }

  toggleDisplayDlmuwDeleteCart() {
    this.setState({
      shouldDisplayDlmuwDeleteCart: !this.state.shouldDisplayDlmuwDeleteCart,
    });
  }

  doEnableReviewOrderBtn() {
    const ccPaymentLoadStatus = this.props.shippingBillingData.payload.shippingBillingObj.enableReviewOrderBtn;
    const taxStatus = this.props.taxSuccessOrFailure;
    const paymentRequired = this.props.paymentRequired;

    if (paymentRequired){
      if (!ccPaymentLoadStatus && taxStatus){
        return false;
      }
      else{
        return true;
      }
    } else {
      return false;
    }
  }

  RenderPaymentOptions = () => {
    return (
      <React.Fragment>
        <Grid.Row>
          <Grid.Column className="payment-panel-padding">
            {/*******************tab structure started here ******************/}
            <Grid.Row>
              <Grid.Column className="paymetric-payment-padding">
                {/*******************tab structure started here ******************/}
                <PaymentOptions
                  errors={this.state.errors}
                  poFields={this.state.fields}
                  validatePOTabFields={this.validatePOTabFields}
                  payTerm={this.props.shippingBillingData.payload.shippingBillingObj.payTerm}
                  updateActivePaymentTab={this.updateActivePaymentTab.bind(
                    this
                  )}
                />
                {/*******************tab structure ends here******************/}
              </Grid.Column>
            </Grid.Row>
            {/*******************tab structure ends here******************/}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12} className="payment-panel-padding">
            <hr />
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    );
  }

  componentDidUpdate(prevProps) {
    const selectedCartList = this.props.cartDetails;
    // if no products in the cart, navigate user to My cart page
    if (!this.props.isFetchingCartList && this.props.isSuccessCartList && selectedCartList.cartList.length < 1) {
      this.backToMyCart();
    }

    if (typeof (this.props.taxSuccessOrFailure) !== 'undefined' &&
      !this.props.taxSuccessOrFailure &&
      prevProps.taxSuccessOrFailure !== this.props.taxSuccessOrFailure
    ) {
      window.scroll(0, 0);
    }

  }

  async componentDidMount() {

    const userId = this.props.userValidationData.payload.userInfo.customer_sub;
    await this.props.checkExpiredContracts(userId);

    // ASDS-955
    logInfo('this.props:', this.props);
    this.props.loadShippingBillingDefaults();
    this.props.resetCCLoadCount();
    let soldToUserObj: AddressDetails | undefined = this.props.soldToShipTo.soldTo;
    logInfo('soldToUserObj ', soldToUserObj);
    if (soldToUserObj && soldToUserObj.sapNumber) {
      let soldToSAPNum = soldToUserObj.sapNumber;

      // ASDS-985
      let payTerm: string = '';

      if ('' === this.props.shippingBillingData.payload.shippingBillingObj.payTerm
        || undefined === this.props.shippingBillingData.payload.shippingBillingObj.payTerm) {
        await this.props.getCustomerCBDStatus(soldToSAPNum);
        let propsShippingBillingObj = this.props.shippingBillingData;
        if (propsShippingBillingObj
          && propsShippingBillingObj.isSuccess
          && propsShippingBillingObj.payload.shippingBillingObj) {
            payTerm = propsShippingBillingObj.payload.shippingBillingObj.payTerm;
            logInfo('payTerm ', payTerm);
        }
        this.setState({
          payTerm: payTerm,
        });
      }
    }

  }

  handleRetry() {
    this.handleSubmit();
  }

  handleSubmit(e?) {
    // Only when triggered from button.
    if (e) {
     e.preventDefault();
    }
    let isErrorInPage: boolean = false;

    // Validation of email address
    if (!isErrorInPage) {
      this.props.validateInputContents();
    }
    if (this.props.taxSuccessOrFailure) {
      isErrorInPage = false;
    }
    else {
      isErrorInPage = true;
      window.scrollTo(0, 0);
    }

    if (this.props.paymentRequired) {
      const activePaymentTab: number = this.state.activePaymentTab;
      // Validation of payment options.
      if (!isErrorInPage &&
        !this.props.shippingBillingData.payload.shippingBillingObj.enableReviewOrderBtn
        && activePaymentTab === CheckoutConstants.CC_ACTIVE_TAB) {
        submitCCFrom();
        isErrorInPage = true;
        this.props.toggleCCValidationLoader();

        setTimeout(() => {
          if (getSubmitSuccessValue() === 1) {
            this.props.updateCCPaymentData()
              .then(() => {
                this.writeToSessionState();
                if (this.props.creditCardPaymentFailure) {
                  this.props.updateCCPaymentFailure(false);
                 }
                this.goToReviewOrderPage();
              });
          }
          else {
            this.props.updateCCPaymentFailure(true);
            window.scrollTo(0, 0);
          }
          this.props.toggleCCValidationLoader();
        },         3000);

      } else if (!isErrorInPage &&
        !this.props.shippingBillingData.payload.shippingBillingObj.enableReviewOrderBtn
        && activePaymentTab === CheckoutConstants.PO_ACTIVE_TAB) {
        if (this.validatePOForm()) {
          let { poDoc } = this.state.fields;
          // if PO document is there then read it otherwise read the avaialble data from state and save it session
          if (poDoc) {
            this.readPODoc(poDoc, this.readPODocument);
          } else {
            let { poNumber, poDate } = this.state.fields;
            poDate = GetFormattedDate(poDate);
            this.props.setPaymentInfo({ poNumber, poDate });
            // If form is valid reset all form fields
            const fields = { ...this.state.fields };
            Object.entries(fields).forEach(entry => {
              fields[entry[0]] = '';
            });
            this.setState({
              fields,
            });

            this.writeToSessionState();
          }
          isErrorInPage = false;
        } else {
          isErrorInPage = true;
        }
      }
    } else {
      this.writeToSessionState();
    }

    if (!isErrorInPage && !this.props.shippingBillingData.payload.shippingBillingObj.enableReviewOrderBtn) {
     if (this.props.creditCardPaymentFailure) {
      this.props.updateCCPaymentFailure(false);
     }
      this.goToReviewOrderPage(); // Go to Review Order Page
    }

    const selectedCartList = this.props.cartDetails;
    if (!this.props.isFetchingCartList && this.props.isSuccessCartList && selectedCartList.cartList.length < 1) {
      this.backToMyCart();
    }

  }

  /* SAVE THE SHIPPING AND BILLING DATA IN SESSION STORAGE, SINCE WE NEED TO RETAIN THIS INFO IN REVIEW ORDER PAGE
  * WE WILL CLEAR THIS INFO WHEN NAVIGATED BACK TO SHIPPING AND BILLING */
  writeToSessionState() {
    const stateFromSession = loadState();
    const updatedState = { ...stateFromSession, shippingBillingData: this.props.shippingBillingData };
    saveState(updatedState);
  }

  validatePOForm() {
    let { poNumber, poDate, poFilePath, poDoc } = this.state.fields;
    let poFormvalidationErrors = {
      poNumberValidationResult: '',
      poDateValidationResult: '',
      poDocValidationResult: ''
    };
    logInfo('validatePOForm poFilePath ', poDate, poFilePath);

    let formIsValid = true;
    poDate = GetFormattedDate(poDate);
    poFormvalidationErrors.poNumberValidationResult = validatePONumber(poNumber);
    poFormvalidationErrors.poDateValidationResult = validatePODate(poDate);
    poFormvalidationErrors.poDocValidationResult = validatePODoc(poDoc);

    this.setState({
      errors: {
        ...this.state.errors,
        poNumber: poFormvalidationErrors.poNumberValidationResult,
        poDate: poFormvalidationErrors.poDateValidationResult,
        poDoc: poFormvalidationErrors.poDocValidationResult,
      }
    });

    Object.keys(poFormvalidationErrors).forEach(function (key) {
      if ('' !== poFormvalidationErrors[key]) {
        formIsValid = false;
      }
    });

    return formIsValid;
  }

  readPODocument(doc: any) {
    let { poNumber, poDate, poDoc } = this.state.fields;
    poDate = GetFormattedDate(poDate);
    let poFilePath = poDoc.name;
    let poContentType = poDoc.type;
    this.props.setPaymentInfo({ poNumber, poDate, poFilePath, doc, poContentType });
    // If form is valid reset all form fields
    const fields = { ...this.state.fields };
    Object.entries(fields).forEach(entry => {
      fields[entry[0]] = '';
    });
    this.setState({
      fields,
    });

    this.writeToSessionState();
  }

  async readPODoc(poDoc: File, readPODocument: any) {
    if (!poDoc) {
      return null;
    }
    const reader = new FileReader();
    // Specify the handler for the `load` event
    let doc;
    reader.onload = function () {
      doc = reader.result; // reading binary data
      doc = btoa(doc); // converting to base64
      readPODocument(doc);
    };
    reader.readAsBinaryString(poDoc);
    return doc;
  }
  validatePOTabFields = (name: string) => (value: any, errValue: any) => {
    this.setState({
      fields: {
        ...this.state.fields,
        [name]: value,
      }
    },            () => {
      const fieldValue = this.state.fields[name];
      if (fieldValue) {
        this.setState({
          errors: { ...this.state.errors, [name]: '' }
        });
    }
      if (errValue) {
        this.setState({
          errors: { ...this.state.errors, [name]: errValue }
        });
      }
    });
  }

  backToMyCart() {
    this.props.history.push(RouteConstants.MY_CART);
  }

  goToReviewOrderPage() {
    this.props.history.push(
      {
        pathname: RouteConstants.REVIEW_ORDER,
        state: { status: 'allow' }
      });
  }

  handlePaymentOptions() {
    let paymentOpt = this.state.openPaymentOptions;
    this.setState({
      openPaymentOptions: !paymentOpt
    });
  }

  backToProductListing() {
    this.props.updateCCPaymentFailure(false);
    this.props.history.push(RouteConstants.PURCHASE_SOFTWARE);
  }

  componentWillMount() {
    // Call API to fetch CBD Flag
  }
  errorContent = () => {
    let errorObj ;
    if (this.props.notifUpdateObj.notifDisplayFlag) {
      errorObj = (
      <Grid.Row>
        <Grid.Column width={12}>
          <Notification
            hasIcon={true}
            title={this.props.notifUpdateObj.notifDisplayMsg}
            severity="important"
          />
        </Grid.Column>
    </Grid.Row>);
    } else if (!this.props.isFetchingCartList && !this.props.isSuccessCartList) {
      errorObj = (
        <Grid.Row data-testid="t-Mycart-error-notification">
          <Grid.Column width={12}>
            <Notification
              hasIcon={true}
              title="There is an error in processing your request."
              severity="critical"
              detailsText="RELOAD THE PAGE"
              onDetailsClick={() => window.location.reload()}
            />
          </Grid.Column>
        </Grid.Row>);
    } else if (this.props.creditCardPaymentFailure) {
      errorObj = (
        <Grid.Row data-testid="t-Mycart-error-notification">
          <Grid.Column width={12}>
            <Notification
              hasIcon={true}
              title="Oopss! Something went wrong"
              severity="critical"
              detailsText="Retry"
              onDetailsClick={this.handleRetry}
            >
            {CheckoutUILabels.CREDIT_CART_PAYMENT_FAILIURE_MSG}
            </Notification>
          </Grid.Column>
        </Grid.Row>
      );
    }
     else {
      errorObj = (<TaxStatusMessage severity={CheckoutUILabels.NOTIFICATION_SEVERITY_CRITICAL} />);
    }
    return errorObj;
  }

  render() {
    const breadcrumbsList: Array<IBreadcrumbLink> = [
      { location: RouteNames.PURCHASE_SOFTWARE },
      { location: RouteNames.MY_CART },
      { location: RouteNames.SHIPPING_BILLING },
  ];
    let errorObj = this.errorContent();
    return (
      <React.Fragment>
      <Layout>
        {/*******************Full width grid ends here******************/}
        {this.props.isFetchingCartList && <GenericLoader text="Fetching Cart details" className="shipping-billing-loader" loading={true} overlayColor="rgb(247, 247, 247)" />}
        {errorObj}
        <Grid.Row>
          <Grid.Column width={12} className="fullwidthRow" >
        <Grid>
          <Grid.Row className="fullwidthRow">
            {/*******************left part of the main body starts here******************/}
            <Grid.Column width={12} mWidth={12} xsWidth={12} className="fullwidthRow shipping-billing-page">
              <BreadcrumbComponent breadcrumbs={breadcrumbsList}/>
            </Grid.Column>
            <Grid.Column width={12} mWidth={12} xsWidth={12} className="shipping-billing-page-heading">
              <h1 className="pageHeading">Billing &amp; Payment</h1>
            </Grid.Column>
          </Grid.Row>
            <Grid.Row >
              <Grid.Column width={9} mWidth={12} className="fullwidthRow shipping-billing-panel">
                <Grid.Row className="fullwidthRow">
                  {/*******************first card component starts here******************/}
                  <Grid.Column width={12} mWidth={12} className="shipping-billing-card-panel">
                    <Card>
                      <Card.Content >
                        <Grid.Row>
                          <Grid.Column width={8} swidth={12} className="address-info">
                            <span className="account-info-text">Account &amp; Address Information</span>
                          </Grid.Column>
                          <Grid.Column width={4} swidth={12} className="change-account">
                            <a className="pull-right change-account--link" data-testid="changeAccount" onClick={this.onChangeAccountClick}>
                              <span>Change Account</span>
                            </a>
                          </Grid.Column>
                        </Grid.Row>
                        <ShippingAndBillingAddress />

                        <Grid.Row>
                          <Grid.Column width={12} className="emailConfir billing-page-subheading">
                            <b>Confirmation Email</b>
                          </Grid.Column>
                          <Grid.Column width={12} className="emailConfir">
                            <InputLabel label="Order confirmation will be sent to" indicator="required" />
                          </Grid.Column>
                        </Grid.Row>
                        <AddEmailAddress />
                      </Card.Content>
                    </Card>
                  </Grid.Column>
                  {/*******************first card component ends here******************/}
                  {/*******************seconds card component starts here******************/}

                  <Grid.Column width={12} mWidth={12} className="payment-panel">
                    <Accordion>
      <Accordion.Content className={this.props.paymentRequired ? '' : 'noPaymentsSubText'} title="Payment Options " disabled={!this.props.paymentRequired} active={this.props.paymentRequired && this.state.openPaymentOptions} onClick={this.handlePaymentOptions}>
                        {this.props.paymentRequired && this.RenderPaymentOptions()}

                        <Grid.Row>
                            <Grid.Column width={12} className="paymment-opts-button">
                              <Button
                                onClick={this.handleSubmit}
                                type="primary"
                                data-testid="submit"
                                content="Review &amp; Place Order"
                                className="pull-right co-primary-button review-placeorder--btn"
                                disabled={this.doEnableReviewOrderBtn()}
                              />
                            </Grid.Column>
                          </Grid.Row>
                      </Accordion.Content>
                    </Accordion>
                  </Grid.Column>

                  {/*******************second card component ends here******************/}
                </Grid.Row>
              </Grid.Column>
              {/*******************left part of the main body ends here******************/}
              {/*************Order Summary block********************/}

              <Grid.Column className='order-summary-panel' width={3} mWidth={12}>
                <OrderSummery>
                  <div className="placeorder--div">
                    <Button
                      onClick={this.handleSubmit}
                      type="primary"
                      content="Review &amp; Place Order"
                      className="co-primary-button placeorder--btn "
                      disabled={this.doEnableReviewOrderBtn()}
                    />
                  </div>
                </OrderSummery>
              </Grid.Column>
            </Grid.Row>
        </Grid>
        </Grid.Column>
        </Grid.Row>
        {this.state.shouldDisplayDeleteCart
          &&
          <DeleteMSAProduct
            open={true}
            onClose={this.toggleDisplayDeleteCart}
            onContinue={this.toggleSelectAccount}
          />
          } {/* ASDS-686 */}
          {this.state.shouldDisplayDlmuwDeleteCart && (
            <DeleteDLMUWProduct
              open={true}
              onClose={this.toggleDisplayDlmuwDeleteCart}
              onContinue={this.toggleSelectAccount}
            />
          )}

        {this.state.shouldDisplaySelectAccount
          &&
          <SelectAccount open={true} onClose={this.toggleSelectAccount} onContinue={this.toggleSelectAccount} />
        }

      </Layout>
      </React.Fragment>
    );
  }
}

function shippingAndBillingMapStateToProps(state) {
  const soldToShipTo = mapSelectAccountToProps(state);
  const shippingBillingData = state.shippingBillingData;
  const { isFetching, isSuccess, taxSuccessOrFailure } = state.orderSummary.orderSummary;
  const notifUpdateObj = state.configAPUData.payload.contractExpireNotif;
  const abstractView = state.cartDetails.abstractView;
  const selectedCartList = state.cartDetails.selectedCartList;

  if (!isFetching && isSuccess) {
    return {
      soldToShipTo,
      shippingBillingData,
      paymentRequired: shippingBillingData.payload.shippingBillingObj.paymentRequired,
      taxSuccessOrFailure: taxSuccessOrFailure,
      notifUpdateObj,
      cartDetails: abstractView.cartDetails,
      isFetchingCartList: abstractView.isFetching,
      isSuccessCartList: abstractView.isSuccess,
      selectedCartList: selectedCartList,
      userValidationData: state.userValidationData,
      creditCardPaymentFailure: shippingBillingData.payload.shippingBillingObj.creditCardPaymentFailure
    };
  }
  else {
    return {
      soldToShipTo,
      shippingBillingData,
      paymentRequired: shippingBillingData.payload.shippingBillingObj.paymentRequired,
      notifUpdateObj,
      cartDetails: abstractView.cartDetails,
      isFetchingCartList: abstractView.isFetching,
      isSuccessCartList: abstractView.isSuccess,
      selectedCartList: selectedCartList,
      userValidationData: state.userValidationData,
      creditCardPaymentFailure: shippingBillingData.payload.shippingBillingObj.creditCardPaymentFailure,
    };
  }
}

export default connect(shippingAndBillingMapStateToProps, {
  getCustomerCBDStatus: ShippingBillingActions.getCustomerCBDStatus,
  setPaymentInfo: ShippingBillingActions.setPaymentInfo,
  validateInputContents: ShippingBillingActions.validateInputContents,
  updateCCPaymentData: ShippingBillingActions.updateCCPaymentData,
  incrementCount: PaymetricActions.incrementCount,
  resetCCLoadCount: PaymetricActions.resetCCLoadCount,
  toggleCCValidationLoader: ShippingBillingActions.updateIsValidatingFlag,
  identifyTabLevelError: ShippingBillingActions.identifyTabLevelError,
  loadShippingBillingDefaults: ShippingBillingActions.loadShippingBillingDefaults,
  checkExpiredContracts: ConfigureAPUActions.checkExpiredContracts,
  updateCCPaymentFailure: ShippingBillingActions.updateCCPaymentFailure,

})(withRouter(ShippingAndBilling));